export const DOUBAO_VOICE_CHANNEL_TYPE = 52;
export const ALIBABA_VOICE_CHANNEL_TYPE = 49;

export const ALIBABA_XINGYU_MODELS = [
  'xingyu-chat',
  'xingyu-asr',
  'xingyu-tts',
  'xingyu-voice-clone',
];

export const DOUBAO_VOICE_MODELS = [
  'xingyu-asr',
  'xingyu-tts',
  'xingyu-voice-clone',
];

export function createDoubaoVoiceConfig() {
  return {
    app_id: '',
    secret_key: '',
    asr_resource_id: 'volc.seedasr.sauc.duration',
    tts_resource_id: 'seed-tts-2.0',
    tts_clone_resource_id: 'seed-icl-2.0',
    clone_resource_id: 'volc.megatts.voiceclone',
    clone_api_key: '',
    preset_voice: '',
  };
}

export function createAlibabaVoiceConfig() {
  return {
    alibaba_asr_model: 'paraformer-realtime-v2',
    alibaba_tts_model: 'cosyvoice-v3-flash',
    alibaba_clone_model: 'voice-enrollment',
    alibaba_preset_voice: 'longanyang',
  };
}

export function validateAlibabaVoiceChannel(apiKey, config) {
  const required = [
    apiKey,
    config.alibaba_asr_model,
    config.alibaba_tts_model,
    config.alibaba_clone_model,
    config.alibaba_preset_voice,
  ];
  return required.every((value) => String(value || '').trim() !== '')
    ? ''
    : '请完整填写阿里百炼 API Key、模型名称和默认音色';
}

export function validateDoubaoVoiceChannel(accessToken, config) {
  const required = [
    accessToken,
    config.app_id,
    config.asr_resource_id,
    config.tts_resource_id,
    config.tts_clone_resource_id,
    config.clone_resource_id,
    config.clone_api_key,
    config.preset_voice,
  ];
  return required.every((value) => String(value || '').trim() !== '')
    ? ''
    : '请完整填写豆包语音渠道的认证信息、资源 ID 和默认音色';
}
